import { snapshot } from 'valtio';
import { Nullable } from 'common-types';
import settingsService from '../services';
import { closeInviteUserModal } from '../store-actions/invite-user-store-actions';
import InviteMemberStore from '../stores/invite-user-store';
import {
  InvitationInput,
  PendingInvitationMember,
} from '../types/members-types';

export const createInvitation = async (
  invitationInput: InvitationInput,
): Promise<void> => {
  InviteMemberStore.isInviteButtonLoading = true;

  const createInvitationResponse: Nullable<PendingInvitationMember> =
    await settingsService.createInvitation.execute(invitationInput);

  if (!createInvitationResponse) {
    InviteMemberStore.isInviteButtonLoading = false;
    return;
  }

  const { pendingInvitationMembers: pendingInvitations } =
    snapshot(InviteMemberStore);

  InviteMemberStore.pendingInvitationMembers = [
    ...pendingInvitations,
    createInvitationResponse,
  ];
  InviteMemberStore.isInviteButtonLoading = false;
  closeInviteUserModal();
};
